import React from 'react'

const REGEX_LABEL = /^(.+?)(\s+:)?\s*$/

export function adjustLabelForOptionality(label: string) {
  const result = label.match(REGEX_LABEL)
  const [, coreLabel, suffix] = result || []
  return (
    <>
      {coreLabel}
      {suffix}
    </>
  )
}
